module.exports = __webpack_public_path__ + "static/media/polytope_3_3_52_layers_8_8.a34cc168.gif";